import api from './api';

class CopyService {
  // Copy a public deck to user's collection
  async copyDeck(deckId: string): Promise<{ message: string; deck: any }> {
    const response = await api.post(`/decks/${deckId}/copy`);
    return response.data;
  }

  // Copy a public quiz to user's collection
  async copyQuiz(quizId: string): Promise<{ message: string; quiz: any }> {
    const response = await api.post(`/quizzes/${quizId}/copy`);
    return response.data;
  }

  // Copy a public match to user's collection
  async copyMatch(matchId: string): Promise<{ message: string; match: any }> {
    const response = await api.post(`/matches/${matchId}/copy`);
    return response.data;
  }
}

export default new CopyService();